import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import ButtonDeprecated, { BUTTON_THEME_GRAY_GREYCLIFF } from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrModalV2 from 'client/components/SrModalV2/SrModalV2';
import SrReportBugForm from 'client/components/SrReportBugForm';

const SrReportBugButton = ({ userId, listingId, section }) => {
  const [reportBugModalIsOpen, setReportBugModalIsOpen] = useState(false);

  const onReportBugClick = useCallback(() => {
    setReportBugModalIsOpen(true);
  }, []);

  const onCloseModal = useCallback(() => {
    setReportBugModalIsOpen(false);
  }, []);

  const onBugReportSubmit = useCallback(() => {
    onCloseModal();
    global.alert('Bug report submitted successfully.');
  }, [onCloseModal]);

  return (
    <div>
      <SrBox margin="20px 0" maxWidth="250px">
        <ButtonDeprecated
          disabled={reportBugModalIsOpen}
          onClick={onReportBugClick}
          theme={BUTTON_THEME_GRAY_GREYCLIFF}
          type="button"
        >
          Report a Bug 🐞
        </ButtonDeprecated>
      </SrBox>
      {reportBugModalIsOpen && (
        <SrModalV2 showCloseButton={false} contentMaxWidth="555px">
          <SrReportBugForm
            userId={userId}
            listingId={listingId}
            section={section}
            onSubmit={onBugReportSubmit}
            onClose={onCloseModal}
          />
        </SrModalV2>
      )}
    </div>
  );
};

SrReportBugButton.propTypes = {
  userId: PropTypes.number,
  listingId: PropTypes.number,
  section: PropTypes.string.isRequired,
};

SrReportBugButton.displayName = 'SrReportBugButton';

export default SrReportBugButton;
